// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutWithFooter_container__1FZgt","body":"LayoutWithFooter_body__9jaou","footer":"LayoutWithFooter_footer__1bVIG"};